module.exports = __webpack_public_path__ + "img/lesson8.9a18b5e1.png";